import { FC } from 'react';
import * as Sentry from '@sentry/react';
import safeStringify from 'fast-safe-stringify';

import PharmaprixPharmacistOwners from '@/components/pharmaprix-pharmacist-owners/index';
import { getStoreLocatorPharmacistOwners } from '@/api/store-locator';

export const getServerSideProps = async ({ req, query }: any) => {
  const { lang } = query;
  try {
    const data = await getStoreLocatorPharmacistOwners(req, lang);
    return { props: data };
  } catch (error: any) {
    Sentry.captureMessage('Error fetching store locator pharmacist owners: ' + error.response);
    console.error('Error fetching store locator pharmacist owners:', safeStringify(error.response));
    return { props: { error: true } };
  }
};

const PharmacistOwnersPage: FC = (props: any) => {
  return <PharmaprixPharmacistOwners {...props} />;
};

export default PharmacistOwnersPage;
